import React, {useEffect, useState} from 'react'
import Axios from 'axios'
import {Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem} from 'reactstrap'
import {Link} from 'react-router-dom'
import styles from './Navbar.module.css'
import logo from '../img/logo.png'
import {API_URL} from '../../ApiUrl.js'

function MyNavbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [type, setType] = useState([])
  const [errorType, setErrorType] = useState('')

  const toggle = () => setDropdownOpen(!dropdownOpen)
  const toggleMenu = () => setMenuOpen(!menuOpen)

  const getType = async () => {
    try {
      const res = await Axios.get(`${API_URL}/api/type`)
      const sorted = res.data.sort((a, b) => b.label.localeCompare(a.label, 'fr'))
      setType(sorted)
    } catch (err) {
      setErrorType(err)
    }
  }

  useEffect(() => {
    getType()
  }, [])

  const handleScrollToTop = () => {
    window.scrollTo(0, 0)
    setMenuOpen(false)
  }

  return (
    <nav className={styles.navBar}>
      {errorType && (
        <p style={{color: 'red', fontSize: '10px', position: 'absolute', top: 0}}>
          Erreur de chargement
        </p>
      )}

      {/* Logo */}
      <div className={styles.firstItem}>
        <Link to="/" onClick={handleScrollToTop} className={styles.logoLink}>
          <img className={styles.logo} src={logo} alt="logo" />
          <h1 className={styles.logoText}>ICK</h1>
        </Link>
      </div>

      {/* Desktop nav */}
      <Nav className={styles.navLinks}>
        <Dropdown
          nav
          isOpen={dropdownOpen}
          toggle={toggle}
          className={styles.secondItem}
        >
          <DropdownToggle nav caret className={styles.navItemLink}>
            Galerie
          </DropdownToggle>
          <DropdownMenu className={styles.dropdownMenuStyle}>
            {type.map((item) => (
              <Link
                key={item.id}
                to={`/galery/${item.id}`}
                className={styles.dropdownMenuNavLink}
                onClick={handleScrollToTop}
              >
                {item.label}
              </Link>
            ))}
          </DropdownMenu>
        </Dropdown>

        <NavItem className={styles.navItem}>
          <Link to="/events" className={styles.navItemLink} onClick={handleScrollToTop}>
            Évènements
          </Link>
        </NavItem>

        <NavItem className={styles.navItem}>
          <Link to="/contact" className={styles.navItemLink} onClick={handleScrollToTop}>
            Contact
          </Link>
        </NavItem>
      </Nav>

      {/* Burger button - mobile only */}
      <button
        className={`${styles.burgerButton} ${menuOpen ? styles.open : ''}`}
        onClick={toggleMenu}
        aria-label="Menu"
      >
        <span />
        <span />
        <span />
      </button>

      {/* Mobile menu */}
      {menuOpen && (
        <div className={styles.mobileMenu}>
          <span className={styles.mobileGalleryLabel}>Galerie</span>
          {type.map((item) => (
            <Link
              key={item.id}
              to={`/galery/${item.id}`}
              className={styles.dropdownMenuNavLink}
              onClick={handleScrollToTop}
            >
              {item.label}
            </Link>
          ))}

          <Link to="/events" className={styles.navItemLink} onClick={handleScrollToTop}>
           Évènements
          </Link>

          <Link to="/contact" className={styles.navItemLink} onClick={handleScrollToTop}>
            Contact
          </Link>
        </div>
      )}
    </nav>
  )
}

export default MyNavbar
